export enum UserRolesEnum {
  tmsAdministrator = 'tms_administrator',
}
